import React from 'react';
import { Box, BoxProps } from '@chakra-ui/react';

export const Card: React.FC<BoxProps> = ({ children, ...rest }) => {
    return (
        <Box bg="white" boxShadow="md" p="4" rounded="md" {...rest}>
            {children}
        </Box>
    );
};
